import { render, staticRenderFns } from "./FormWizarInstallment.vue?vue&type=template&id=6226423e&"
import script from "./FormWizarInstallment.vue?vue&type=script&lang=js&"
export * from "./FormWizarInstallment.vue?vue&type=script&lang=js&"
import style0 from "./FormWizarInstallment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports